import * as React from "react";
import { SVGProps } from "react";
export const CaretLeftIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.167 12.688L8.125 10.646C8.04167 10.5627 7.97567 10.4653 7.927 10.354C7.87834 10.2433 7.854 10.1323 7.854 10.021C7.854 9.90966 7.87834 9.79866 7.927 9.688C7.97567 9.57666 8.04167 9.47933 8.125 9.396L10.167 7.354C10.4443 7.07667 10.7637 7.01067 11.125 7.156C11.4863 7.302 11.667 7.56933 11.667 7.958V12.062C11.667 12.4653 11.4863 12.7397 11.125 12.885C10.7637 13.031 10.4443 12.9653 10.167 12.688Z"
            fill="currentColor"
        />
    </svg>
);
CaretLeftIcon.displayName = "CaretLeftIcon";
